<!--<div  *ngIf="!initialLoaing; else loading" >-->

<div style="display:block;"  *ngIf="stream" > 
    


</div> 
     
